import { RepeatWrapping, TextureLoader, type Texture } from 'three';

// Paper normal + roughness maps for the card MeshStandardMaterial —
// tiled 3x3. anisotropy is set from the renderer's capability so the
// paper stays sharp at oblique viewing angles. A missing file returns
// null and the material degrades to plain color.
async function loadPaperTextures(anisotropy = 1): Promise<{ normal: Texture | null; roughness: Texture | null }> {
    const loader = new TextureLoader();
    const [normalRes, roughnessRes] = await Promise.allSettled([
        loader.loadAsync('/models/textures/paper_normal.png'),
        loader.loadAsync('/models/textures/paper_roughness.png'),
    ]);
    return {
        normal: normalRes.status === 'fulfilled' ? _configure(normalRes.value, anisotropy) : null,
        roughness: roughnessRes.status === 'fulfilled' ? _configure(roughnessRes.value, anisotropy) : null,
    };
}

function _configure(tex: Texture, anisotropy: number): Texture {
    tex.wrapS = RepeatWrapping;
    tex.wrapT = RepeatWrapping;
    tex.repeat.set(3, 3);
    tex.anisotropy = anisotropy;
    tex.needsUpdate = true;
    return tex;
}

export { loadPaperTextures };
